import { SsoTokenGate } from '@/app/routes/AppRoutes';

function App() {
  return <SsoTokenGate />;
}

export default App;
